// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.table-view {
  width: 100%;
  border-collapse: separate;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--primary-color-dark-500);
  background-color: var(--primary-color-light-500);
  border-radius: 8px;
}
.table-view__wrapper {
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 0px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
  scrollbar-color: var(--primary-color-dark-200, #ccc) transparent;
  -ms-overflow-style: auto;
}
.table-view__wrapper::-webkit-scrollbar {
  height: 4px;
}
.table-view__wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.table-view__wrapper::-webkit-scrollbar-thumb {
  background-color: #ccc;
  background-color: var(--primary-color-dark-200, #ccc);
  border-radius: 2px;
}
@media (max-width: 768px) {
  .table-view__wrapper--responsive {
    font-size: 0.75rem;
  }
}
.table-view__caption {
  padding: 1rem;
  font-size: 1.125rem;
  font-weight: 600;
  text-align: left;
  caption-side: top;
  color: var(--primary-color-dark-500);
  background-color: var(--primary-color-light-400);
  border-bottom: 2px solid var(--primary-color-dark-500);
}
.table-view__header {
  background-color: var(--primary-color-light-400);
  border-bottom: 2px solid var(--primary-color-dark-500);
}
.table-view__header-cell {
  padding: 0.625rem 0.875rem;
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid var(--primary-color-dark-500);
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
  position: relative;
}
.table-view__header-cell:nth-child(1) {
  border-top-left-radius: 8px;
}
.table-view__header-cell:last-child {
  border-top-right-radius: 8px;
}
.table-view__header-cell--sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s ease-in-out;
}
.table-view__header-cell--sortable:hover {
  background-color: var(--primary-color-light-500);
}
.table-view__header-cell--sortable:focus {
  outline: 2px solid var(--secondary-color-500);
  outline-offset: -2px;
  background-color: var(--primary-color-light-200);
}
.table-view__header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  min-width: 0;
}
.table-view__header-content > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}
.table-view__sort-icon {
  margin-left: 0.5rem;
  font-size: 0.75rem;
  transition: color 0.2s ease;
}
.table-view__sort-icon--asc {
  color: var(--primary-color-dark-500);
}
.table-view__sort-icon--desc {
  color: var(--primary-color-dark-500);
}
.table-view__sort-icon--none {
  color: var(--primary-color-dark-300);
  opacity: 0.5;
}
.table-view__body {
  background-color: var(--primary-color-light-500);
}
.table-view__row {
  transition: background-color 0.15s ease-in-out;
}
.table-view--striped .table-view__row:nth-child(even) {
  background-color: var(--primary-color-light-300);
}
.table-view--hover .table-view__row:hover {
  background-color: var(--primary-color-light-200);
}
.table-view__row:last-child .table-view__cell:nth-child(1) {
  border-bottom-left-radius: 8px;
}
.table-view__row:last-child .table-view__cell:last-child {
  border-bottom-right-radius: 8px;
}
.table-view__cell {
  padding: 0.625rem 0.875rem;
  border-bottom: 1px solid var(--primary-color-dark-100);
  vertical-align: top;
  word-wrap: break-word;
  word-break: break-word;
}
.table-view--bordered .table-view__cell {
  border-right: 1px solid var(--primary-color-dark-100);
}
.table-view--bordered .table-view__cell:last-child {
  border-right: none;
}
.table-view__na-value {
  color: var(--primary-color-dark-300);
  font-style: italic;
}
.table-view__numeric-value {
  font-weight: 600;
  color: var(--primary-color-dark-500);
}
.table-view__text-with-links {
  word-break: break-word;
  line-height: 1.4;
}
.table-view__link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  padding: 1px 3px;
  transition: all 0.15s ease-in-out;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: baseline;
  border: none;
  border: 0;
}
.table-view__link:hover {
  color: var(--primary-color-dark-700);
  background-color: rgba(0, 102, 204, 0.1);
  background-color: var(--link-hover-bg, rgba(0, 102, 204, 0.1));
  border: 0;
  text-decoration: underline;
}
.table-view__link:focus {
  outline: 2px solid var(--secondary-color-500);
  outline-offset: 2px;
}
.table-view__link:visited {
  color: #6b46c1;
  color: var(--link-visited-color, #6b46c1);
}
.table-view__link::after {
  content: " ↗";
  font-size: 0.75em;
  opacity: 0.6;
  margin-left: 2px;
}
.table-view--bordered {
  border: 1px solid var(--primary-color-dark-500);
}
.table-view--bordered .table-view__header-cell,
.table-view--bordered .table-view__cell {
  border-right: 1px solid var(--primary-color-dark-200);
}
.table-view--bordered .table-view__header-cell:last-child,
.table-view--bordered .table-view__cell:last-child {
  border-right: none;
}
@media (max-width: 768px) {
  .table-view__wrapper--responsive .table-view__header-cell,
  .table-view__wrapper--responsive .table-view__cell {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
  .table-view__wrapper--responsive .table-view__header-cell {
    white-space: normal;
    word-break: break-word;
  }
}
.table-view__container {
  width: 100%;
}
.table-view__export-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0;
  margin-left: 0;
  overflow: visible !important;
  width: 100%;
}
@media screen and (max-width: 600px) {
  .table-view__export-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
.table-view__row-count {
  font-weight: 500;
}
.table-view__export-buttons {
  display: flex !important;
  flex-wrap: wrap;
  gap: 0;
  justify-content: flex-start !important;
  width: 100%;
  max-width: 100%;
  padding: 2px 0 10px 0 !important;
  padding-left: 0 !important;
  overflow: visible !important;
  background: transparent;
  margin: 0 !important;
  margin-left: 0 !important;
}
@media screen and (max-width: 600px) {
  .table-view__export-buttons {
    justify-content: flex-start;
    padding: 10px 0;
    margin: 0;
  }
}
.table-view__export-icon {
  font-size: 1rem;
  line-height: 1;
}
.table-view__export-label {
  white-space: nowrap;
}
@media screen and (max-width: 480px) {
  .table-view__export-label {
    display: none;
  }
}
.table-view__cell--filled {
  color: var(--secondary-color-500);
  font-weight: 500;
  position: relative;
}
.table-view__cell--filled::after {
  content: " *";
  font-size: 0.875em;
  opacity: 0.7;
}
.table-view__cell--calculated {
  cursor: help;
  border-bottom: 1px dashed var(--secondary-color-500);
}
.table-view__cell--unverified {
  color: #f59e0b;
  color: var(--warning-color, #f59e0b);
  cursor: help;
}
.table-view__cell--unverified::before {
  content: "⚠ ";
  font-size: 0.75em;
  opacity: 0.8;
}
.table-view__unverified-hidden {
  color: var(--primary-color-dark-300);
  font-style: italic;
  opacity: 0.5;
}
.table-view__source-link {
  text-decoration: none;
  color: inherit;
}
.table-view__source-link:hover span {
  text-decoration: underline;
  -webkit-text-decoration-style: dotted;
          text-decoration-style: dotted;
}
@media (max-width: 480px) {
  .table-view__wrapper--responsive .table-view__header-cell,
  .table-view__wrapper--responsive .table-view__cell {
    padding: 0.375rem 0.5rem;
    font-size: 0.6875rem;
  }
}

@media print {
  .table-view {
    font-size: 10pt;
  }
  .table-view__wrapper {
    overflow: visible;
    box-shadow: none;
  }
  .table-view__row {
    page-break-inside: avoid;
  }
  .table-view__sort-icon {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Reports/TableView/TableView.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,gDAAA;EACA,kBAAA;AAEF;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EAGA,qBAAA;EACA,iCAAA;EAAA,gEAAA;EACA,wBAAA;AAAJ;AAEI;EACE,WAAA;AAAN;AAGI;EACE,uBAAA;AADN;AAII;EACE,sBAAA;EAAA,qDAAA;EACA,kBAAA;AAFN;AAMM;EADF;IAEI,kBAAA;EAHN;AACF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;AALJ;AAQE;EACE,gDAAA;EACA,sDAAA;AANJ;AASE;EACE,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sDAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AASI;EACE,2BAAA;AAPN;AAUI;EACE,4BAAA;AARN;AAWI;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AATN;AAWM;EACE,gDAAA;AATR;AAYM;EACE,6CAAA;EACA,oBAAA;EACA,gDAAA;AAVR;AAeE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAbJ;AAeI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAbN;AAiBE;EACE,mBAAA;EACA,kBAAA;EACA,2BAAA;AAfJ;AAiBI;EACE,oCAAA;AAfN;AAkBI;EACE,oCAAA;AAhBN;AAmBI;EACE,oCAAA;EACA,YAAA;AAjBN;AAqBE;EACE,gDAAA;AAnBJ;AAsBE;EACE,8CAAA;AApBJ;AAuBM;EACE,gDAAA;AArBR;AAyBI;EACE,gDAAA;AAvBN;AA4BQ;EACE,8BAAA;AA1BV;AA6BQ;EACE,+BAAA;AA3BV;AAiCE;EACE,0BAAA;EACA,sDAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AA/BJ;AAiCI;EACE,qDAAA;AA/BN;AAiCM;EACE,kBAAA;AA/BR;AAoCE;EACE,oCAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,gBAAA;EACA,oCAAA;AAnCJ;AAsCE;EACE,sBAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,SAAA;AArCJ;AAuCI;EACE,oCAAA;EACA,wCAAA;EAAA,8DAAA;EACA,SAAA;EACA,0BAAA;AArCN;AAwCI;EACE,6CAAA;EACA,mBAAA;AAtCN;AAyCI;EACE,cAAA;EAAA,yCAAA;AAvCN;AA0CI;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAxCN;AA4CE;EACE,+CAAA;AA1CJ;AA4CI;;EAEE,qDAAA;AA1CN;AA4CM;;EACE,kBAAA;AAzCR;AA8CE;EAGI;;IAEE,uBAAA;IACA,kBAAA;EA9CN;EAiDI;IACE,mBAAA;IACA,sBAAA;EA/CN;AACF;AAmDE;EACE,WAAA;AAjDJ;AAoDE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,MAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,4BAAA;EACA,WAAA;AAlDJ;AAoDI;EAZF;IAaI,sBAAA;IACA,uBAAA;IACA,SAAA;EAjDJ;AACF;AAoDE;EACE,gBAAA;AAlDJ;AAqDE;EACE,wBAAA;EACA,eAAA;EACA,MAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EAGA,gCAAA;EACA,0BAAA;EAEA,4BAAA;EACA,uBAAA;EAGA,oBAAA;EAGA,yBAAA;AA1DJ;AA4DI;EArBF;IAsBI,2BAAA;IACA,eAAA;IACA,SAAA;EAzDJ;AACF;AA4DE;EACE,eAAA;EACA,cAAA;AA1DJ;AA6DE;EACE,mBAAA;AA3DJ;AA6DI;EAHF;IAII,aAAA;EA1DJ;AACF;AA6DE;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;AA3DJ;AA6DI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AA3DN;AAgEE;EACE,YAAA;EACA,oDAAA;AA9DJ;AAkEE;EACE,cAAA;EAAA,oCAAA;EACA,YAAA;AAhEJ;AAkEI;EACE,aAAA;EACA,iBAAA;EACA,YAAA;AAhEN;AAqEE;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;AAnEJ;AAuEE;EACE,qBAAA;EACA,cAAA;AArEJ;AAuEI;EACE,0BAAA;EACA,qCAAA;UAAA,6BAAA;AArEN;AAyEE;EAGI;;IAEE,wBAAA;IACA,oBAAA;EAzEN;AACF;;AA8EA;EACE;IACE,eAAA;EA3EF;EA6EE;IACE,iBAAA;IACA,gBAAA;EA3EJ;EA8EE;IACE,wBAAA;EA5EJ;EA+EE;IACE,aAAA;EA7EJ;AACF","sourcesContent":[".table-view {\n  width: 100%;\n  border-collapse: separate;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--primary-color-dark-500);\n  background-color: var(--primary-color-light-500);\n  border-radius: 8px;\n\n  &__wrapper {\n    overflow-x: auto; // Allow scroll for wide tables\n    overflow-y: visible;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    margin-bottom: 0px;\n\n    // Show a thin scrollbar so users know they can scroll horizontally\n    scrollbar-width: thin; // Firefox\n    scrollbar-color: var(--primary-color-dark-200, #ccc) transparent; // Firefox\n    -ms-overflow-style: auto; // IE/Edge\n\n    &::-webkit-scrollbar {\n      height: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--primary-color-dark-200, #ccc);\n      border-radius: 2px;\n    }\n\n    &--responsive {\n      @media (max-width: 768px) {\n        font-size: 0.75rem;\n      }\n    }\n  }\n\n  &__caption {\n    padding: 1rem;\n    font-size: 1.125rem;\n    font-weight: 600;\n    text-align: left;\n    caption-side: top;\n    color: var(--primary-color-dark-500);\n    background-color: var(--primary-color-light-400);\n    border-bottom: 2px solid var(--primary-color-dark-500);\n  }\n\n  &__header {\n    background-color: var(--primary-color-light-400);\n    border-bottom: 2px solid var(--primary-color-dark-500);\n  }\n\n  &__header-cell {\n    padding: 0.625rem 0.875rem; // Slightly tighter padding\n    font-weight: 600;\n    text-align: left;\n    border-bottom: 1px solid var(--primary-color-dark-500);\n    white-space: normal; // Changed from nowrap to prevent cutting off\n    word-break: break-word;\n    overflow: visible;\n    text-overflow: clip;\n    position: relative;\n\n    &:nth-child(1) {\n      border-top-left-radius: 8px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 8px;\n    }\n\n    &--sortable {\n      cursor: pointer;\n      user-select: none;\n      transition: background-color 0.15s ease-in-out;\n\n      &:hover {\n        background-color: var(--primary-color-light-500);\n      }\n\n      &:focus {\n        outline: 2px solid var(--secondary-color-500);\n        outline-offset: -2px;\n        background-color: var(--primary-color-light-200);\n      }\n    }\n  }\n\n  &__header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    min-width: 0;\n\n    >span:first-child {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  &__sort-icon {\n    margin-left: 0.5rem;\n    font-size: 0.75rem;\n    transition: color 0.2s ease;\n\n    &--asc {\n      color: var(--primary-color-dark-500);\n    }\n\n    &--desc {\n      color: var(--primary-color-dark-500);\n    }\n\n    &--none {\n      color: var(--primary-color-dark-300);\n      opacity: 0.5;\n    }\n  }\n\n  &__body {\n    background-color: var(--primary-color-light-500);\n  }\n\n  &__row {\n    transition: background-color 0.15s ease-in-out;\n\n    &:nth-child(even) {\n      .table-view--striped & {\n        background-color: var(--primary-color-light-300);\n      }\n    }\n\n    .table-view--hover &:hover {\n      background-color: var(--primary-color-light-200);\n    }\n\n    &:last-child {\n      .table-view__cell {\n        &:nth-child(1) {\n          border-bottom-left-radius: 8px;\n        }\n\n        &:last-child {\n          border-bottom-right-radius: 8px;\n        }\n      }\n    }\n  }\n\n  &__cell {\n    padding: 0.625rem 0.875rem; // Slightly tighter padding\n    border-bottom: 1px solid var(--primary-color-dark-100);\n    vertical-align: top;\n    word-wrap: break-word;\n    word-break: break-word; // Ensure wrapping\n\n    .table-view--bordered & {\n      border-right: 1px solid var(--primary-color-dark-100);\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n\n  &__na-value {\n    color: var(--primary-color-dark-300);\n    font-style: italic;\n  }\n\n  &__numeric-value {\n    font-weight: 600;\n    color: var(--primary-color-dark-500);\n  }\n\n  &__text-with-links {\n    word-break: break-word;\n    line-height: 1.4;\n  }\n\n  &__link {\n    color: var(--primary-color);\n    text-decoration: none;\n    font-weight: 500;\n    padding: 1px 3px;\n    transition: all 0.15s ease-in-out;\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: baseline;\n    border: none;\n    border: 0;\n\n    &:hover {\n      color: var(--primary-color-dark-700);\n      background-color: var(--link-hover-bg, rgba(0, 102, 204, 0.1));\n      border: 0;\n      text-decoration: underline;\n    }\n\n    &:focus {\n      outline: 2px solid var(--secondary-color-500);\n      outline-offset: 2px;\n    }\n\n    &:visited {\n      color: var(--link-visited-color, #6b46c1);\n    }\n\n    &::after {\n      content: ' ↗';\n      font-size: 0.75em;\n      opacity: 0.6;\n      margin-left: 2px;\n    }\n  }\n\n  &--bordered {\n    border: 1px solid var(--primary-color-dark-500);\n\n    .table-view__header-cell,\n    .table-view__cell {\n      border-right: 1px solid var(--primary-color-dark-200);\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    &__wrapper--responsive {\n\n      .table-view__header-cell,\n      .table-view__cell {\n        padding: 0.5rem 0.75rem;\n        font-size: 0.75rem;\n      }\n\n      .table-view__header-cell {\n        white-space: normal;\n        word-break: break-word;\n      }\n    }\n  }\n\n  &__container {\n    width: 100%;\n  }\n\n  &__export-section {\n    display: flex;\n    justify-content: flex-start; // Move to the left\n    align-items: center;\n    gap: 0; // Remove gap as there is likely only one child, or handle spacing in child\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 0; // Ensure no padding\n    margin-left: 0; // Ensure no left margin\n    overflow: visible !important;\n    width: 100%;\n\n    @media screen and (max-width: 600px) {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 1rem;\n    }\n  }\n\n  &__row-count {\n    font-weight: 500;\n  }\n\n  &__export-buttons {\n    display: flex !important;\n    flex-wrap: wrap;\n    gap: 0;\n    justify-content: flex-start !important;\n    width: 100%;\n    max-width: 100%;\n\n    // Minimal top padding to stick to table\n    padding: 2px 0 10px 0 !important;\n    padding-left: 0 !important;\n\n    overflow: visible !important;\n    background: transparent;\n\n    // Remove top margin\n    margin: 0 !important;\n\n    // Moving fully inside (resetting to 0) as per request to move \"more inside\"\n    margin-left: 0 !important;\n\n    @media screen and (max-width: 600px) {\n      justify-content: flex-start;\n      padding: 10px 0;\n      margin: 0;\n    }\n  }\n\n  &__export-icon {\n    font-size: 1rem;\n    line-height: 1;\n  }\n\n  &__export-label {\n    white-space: nowrap;\n\n    @media screen and (max-width: 480px) {\n      display: none;\n    }\n  }\n\n  &__cell--filled {\n    color: var(--secondary-color-500);\n    font-weight: 500;\n    position: relative;\n\n    &::after {\n      content: ' *';\n      font-size: 0.875em;\n      opacity: 0.7;\n    }\n  }\n\n  // Calculated value: shows tooltip cursor\n  &__cell--calculated {\n    cursor: help;\n    border-bottom: 1px dashed var(--secondary-color-500);\n  }\n\n  // Unverified value: orange color + warning icon\n  &__cell--unverified {\n    color: var(--warning-color, #f59e0b);\n    cursor: help;\n\n    &::before {\n      content: '⚠ ';\n      font-size: 0.75em;\n      opacity: 0.8;\n    }\n  }\n\n  // Cell hidden when hideUnverified=true\n  &__unverified-hidden {\n    color: var(--primary-color-dark-300);\n    font-style: italic;\n    opacity: 0.5;\n  }\n\n  // Source hyperlink wrapping a numeric value\n  &__source-link {\n    text-decoration: none;\n    color: inherit;\n\n    &:hover span {\n      text-decoration: underline;\n      text-decoration-style: dotted;\n    }\n  }\n\n  @media (max-width: 480px) {\n    &__wrapper--responsive {\n\n      .table-view__header-cell,\n      .table-view__cell {\n        padding: 0.375rem 0.5rem;\n        font-size: 0.6875rem;\n      }\n    }\n  }\n}\n\n@media print {\n  .table-view {\n    font-size: 10pt;\n\n    &__wrapper {\n      overflow: visible;\n      box-shadow: none;\n    }\n\n    &__row {\n      page-break-inside: avoid;\n    }\n\n    &__sort-icon {\n      display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
